import { useCallback, useState } from "react";
import axios from "../../../lib/axios";
import useSetTokenState from "./useSetTokenState";
import { useLocation, useNavigate } from "react-router-dom";

function useUserRegister() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const setToken = useSetTokenState();

  const registerUser = useCallback(
    async (name, email, password, passConfirm) => {
      setLoading(true);
      try {
        const res = await axios.post("/api/auth/register", {
          name: name,
          email: email,
          password: password,
          password_confirmation: passConfirm,
        });

        const data = res.data;
        console.log(data);
        const authToken = {
          email,
          accessToken: data?.access_token,
          expiresIn: data?.expires_in,
          tokenType: data?.token_type,
        };

        setToken(authToken);

        navigate("/app", { state: { prevPath: location.pathname } });

        return data;
      } catch (err) {
        console.log(err.response);
        setError(err.response?.data);
        return err.response?.data;
      } finally {
        setLoading(false);
      }
    },
    [location, setToken]
  );

  return [registerUser, loading, error];
}

export default useUserRegister;
